import React from 'react';
import styles from './ORSMSlugForm.module.scss';
import Text from '../../../../Components/Base/Text/Text';
import InputField from '../../../../Components/Form/components/InputField';
import Button from '../../../../Components/Button/Button';
import { Theme } from '../../../../Enums/Theme.enum';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import { UseFormReturn } from 'react-hook-form';
import { useAppContext } from '../../../../Services/AppContext';

interface Props {
	formMethods: UseFormReturn;
	onSlugAvailabilityCheck: () => void;
	isLoadingVerification: boolean;
}

const ORSMSlugForm: React.FC<Props> = ({
	formMethods,
	onSlugAvailabilityCheck,
	isLoadingVerification,
}) => {
	const { isProduction } = useAppContext();

	let suffix = `.meddi.com`;

	if (!isProduction) {
		suffix = `.meddi-devcal.cz`;
	}

	return (
		<FormWrapper formMethods={formMethods}>
			<div>
				<Text
					tx='component.ORSMSlugForm.pickYourDomain'
					className={styles.title}
				/>
				<Text
					tx='component.ORSMSlugForm.yourUniqueAddress'
					className={styles.subtitle}
				/>
			</div>
			<div className={styles.inline}>
				<InputField
					name='slug'
					isRequired
					suffix={suffix}
					className={styles.input}
				/>
				<Button
					title='component.ORSMSlugForm.verifyAvailability'
					theme={Theme.BLUE}
					onClick={onSlugAvailabilityCheck}
					className='ml-3'
					isLoading={isLoadingVerification}
				/>
			</div>
		</FormWrapper>
	);
};

export default ORSMSlugForm;
